import { useEffect, useState } from "react";
import authorizationStore from "../../../common/auth/authorizationStore";
import jwtUtils from "../../../common/utils/jwtUtils";

export const useUserAccess = () => {
  const [ isBuAdmin, setIsBuAdmin ] = useState(false);
  const [ isRxAdmin, setIsRxAdmin ] = useState(false);

  const definedUserAccessFieldAccess = async () => {
    try {
      const token = await authorizationStore.getToken({ skipRefetch: true });
      setIsBuAdmin(jwtUtils.isLoggedUserBUAdmin(token));
      setIsRxAdmin(jwtUtils.isLoggedUserRxAdmin(token));
    } catch {
      return;
    }
  };

  useEffect(() => {
    definedUserAccessFieldAccess();
  },[]);

  return { isUserAccessFieldDisabled: !isRxAdmin && !isBuAdmin, options: { isUserAdmin: isRxAdmin || isBuAdmin }};
}
